import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormGroup } from '@angular/forms';
import { environment } from '@env/environment';
import { AppConstant } from '../../constants';
import { UserListFilterModel } from '../../../feature/super-admin/models/client';
@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private http: HttpClient) { }

  addCustomerSupportUser(form: FormGroup) {
    return this.http.post(environment.baseUrl + AppConstant.ADD_CUSTOMER_SUPPORT, form);
  }
  UpdateCustomerSupportUser(form: FormGroup) {
    return this.http.post(environment.baseUrl + AppConstant.UPDATE_CUSTOMER_SUPPORT, form);
  }
  addNewOpenApiUser(form: FormGroup) {
    return this.http.post(environment.baseUrl + AppConstant.ADD_OPEN_API_USER, form);
  }
  GetUserList(userListFilterModel: UserListFilterModel){
    return this.http.post(environment.baseUrl + AppConstant.CUSTOMER_SUPPORT_USER_LIST, userListFilterModel);
  }
  GetCSRUser(userId){
    return this.http.get(environment.baseUrl + AppConstant.CUSTOMER_SUPPORT_USER + '?UserId=' + userId);
  }
  changeStatus(customerSeviceUserId: any, userId: any, markActive: boolean) {
    return this.http.get(environment.baseUrl + AppConstant.CHANGE_STATUS_CUSTOMER_SUPPORT_USER + '?CustomerServiceUserId=' + customerSeviceUserId + '&UserId=' + userId + '&MarkActive=' + markActive);
  }
  saveReleaseNote(note: any) {
    return this.http.post(environment.baseUrl + AppConstant.SAVE_RELEAE_NOTE, note);
  }
  getOpenApiUserList(userListFilterModel: UserListFilterModel) {
    return this.http.post(environment.baseUrl + AppConstant.ADD_OPEN_API_USER_LIST, userListFilterModel);
  }
  ResendInitialEmail(userId) {
    return this.http.get(environment.baseUrl + AppConstant.RESEND_INITIAL_EMAIL + '?UserId=' + userId);
  }
}
